/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LayerResponseDto } from './LayerResponseDto';
import {
    LayerResponseDtoFromJSON,
    LayerResponseDtoFromJSONTyped,
    LayerResponseDtoToJSON,
    LayerResponseDtoToJSONTyped,
} from './LayerResponseDto';
import type { PaginationDto } from './PaginationDto';
import {
    PaginationDtoFromJSON,
    PaginationDtoFromJSONTyped,
    PaginationDtoToJSON,
    PaginationDtoToJSONTyped,
} from './PaginationDto';

/**
 * 
 * @export
 * @interface LayerPaginationResponseDto
 */
export interface LayerPaginationResponseDto {
    /**
     * 
     * @type {PaginationDto}
     * @memberof LayerPaginationResponseDto
     */
    pagination: PaginationDto;
    /**
     * 
     * @type {Array<LayerResponseDto>}
     * @memberof LayerPaginationResponseDto
     */
    items: Array<LayerResponseDto>;
}

/**
 * Check if a given object implements the LayerPaginationResponseDto interface.
 */
export function instanceOfLayerPaginationResponseDto(value: object): value is LayerPaginationResponseDto {
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function LayerPaginationResponseDtoFromJSON(json: any): LayerPaginationResponseDto {
    return LayerPaginationResponseDtoFromJSONTyped(json, false);
}

export function LayerPaginationResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): LayerPaginationResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'pagination': PaginationDtoFromJSON(json['pagination']),
        'items': ((json['items'] as Array<any>).map(LayerResponseDtoFromJSON)),
    };
}

export function LayerPaginationResponseDtoToJSON(json: any): LayerPaginationResponseDto {
    return LayerPaginationResponseDtoToJSONTyped(json, false);
}

export function LayerPaginationResponseDtoToJSONTyped(value?: LayerPaginationResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'pagination': PaginationDtoToJSON(value['pagination']),
        'items': ((value['items'] as Array<any>).map(LayerResponseDtoToJSON)),
    };
}

